import { render, staticRenderFns } from "./pay-user 无小程序跳转备份.vue?vue&type=template&id=53aa9c82&scoped=true"
import script from "./pay-user 无小程序跳转备份.vue?vue&type=script&lang=js"
export * from "./pay-user 无小程序跳转备份.vue?vue&type=script&lang=js"
import style0 from "./pay-user 无小程序跳转备份.vue?vue&type=style&index=0&id=53aa9c82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53aa9c82",
  null
  
)

export default component.exports